/**
 * Created by tofaelraju on 3/24/17.
 */

import actions from './types';

export function asyncStart() {

    const action ={
        type: actions.ASYNC_REQ_START
    }

    return action;
}

export function asyncEnd() {

    const action ={
        type: actions.ASYNC_REQ_END
    }

    return action;
}

export function showFeedback(data) {

  const action ={
    type: actions.NOTIFIY_USER,
    data:data
  }

  return action;
}

export function resetFeedbackBar() {

  const action ={
    type: actions.RESET_FEEDBACKBAR
  }

  return action;
}


// WEBPACK FOOTER //
// ./src/actions/application.js